import React, { useEffect, useState } from 'react';
import Table from "./Table";
import LoadingAnimations from "../Loaders/Skeleton";

const columns = [
  { Header: "User", accessor: "userName", minWidth: 170 },
  { Header: "Total Time", accessor: "formattedTime", minWidth: 120 },
  { Header: "Sessions", accessor: "sessionCount", minWidth: 80 }
];

export default function InspectionTimingSummaryTable({ timingData, loading, error }) {
  const [data, setData] = useState(null);

  // Helper function to format duration from seconds
  const formatDuration = (seconds) => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor(seconds % 3600 / 60);
    const secs = seconds % 60;
    
    if (hours > 0) {
      return `${hours}h ${minutes}m ${secs}s`;
    } else if (minutes > 0) {
      return `${minutes}m ${secs}s`;
    }
    return `${secs}s`;
  };

  useEffect(() => {
    if (timingData && timingData.length > 0) {
      // Calculate totals
      const totalSeconds = timingData.reduce((sum, item) => sum + (item.totalSeconds || 0), 0);
      const totalSessions = timingData.reduce((sum, item) => sum + (item.sessionCount || 0), 0);
      
      // Add a total row at the end
      const dataWithTotal = [
        ...timingData,
        {
          userId: 'total',
          userName: <strong>Total</strong>,
          formattedTime: <strong>{formatDuration(totalSeconds)}</strong>,
          sessionCount: <strong>{totalSessions}</strong>,
          totalSeconds: totalSeconds
        }
      ];
      setData(dataWithTotal);
    } else {
      setData([]);
    }
  }, [timingData]);

  // Don't show anything if there's no data
  if (!loading && (!data || data.length === 0)) {
    return null;
  }

  if (loading) {
    return (
      <div className="tw-pl-6 tw-pt-6">
        <h3>Timing Summary <i className="fad fa-clock"/></h3>
        <LoadingAnimations height={40}/>
      </div>
    );
  }

  if (error) {
    return (
      <div className="tw-pl-6 tw-pt-6">
        <h3>Timing Summary <i className="fad fa-clock"/></h3>
        <div className="tw-text-red-600">Failed to load timing data</div>
      </div>
    );
  }

  return (
    <div className="tw-pl-6 tw-pt-6">
      <h3>Timing Summary <i className="fad fa-clock"/></h3>
      <div className="table table-sm tw-text-xs md:tw-text-sm">
        <Table columns={columns} data={data}/>
      </div>
    </div>
  );
}